"use client"

import {Moon, Sun, Sparkles} from "lucide-react"
import {useTheme} from "next-themes"
import {Button} from "@/components/ui/button"
import {useEffect, useState} from "react"

export function ThemeToggle() {
  const { theme, setTheme } = useTheme()
  const [mounted, setMounted] = useState(false)
  const [isRotating, setIsRotating] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  const handleToggle = () => {
    setIsRotating(true)
    setTheme(theme === "light" ? "dark" : "light")
    setTimeout(() => setIsRotating(false), 400)
  }

  if (!mounted) {
    return (
      <Button 
        variant="outline" 
        size="sm" 
        className="w-9 h-9 border-2 border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-sm hover:shadow-md transition-all duration-300"
      >
        <Sun className="h-4 w-4 text-gray-500 dark:text-gray-400" />
      </Button>
    )
  }

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleToggle}
      className="w-9 h-9 border-0 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 shadow-sm hover:shadow-lg transition-all duration-300 hover:scale-110 active:scale-95 group relative overflow-hidden"
    >
      {/* No gradient background per design system */}
      
      {/* Icons with rotation animation */}
      <div className={`relative transition-transform duration-300 ${
        isRotating ? 'rotate-[360deg]' : ''
      }`}>
        {theme === "light" ? (
          <Moon className="h-4 w-4 text-primary transition-all duration-300 group-hover:scale-110" />
        ) : (
          <Sun className="h-4 w-4 text-primary transition-all duration-300 group-hover:scale-110 group-hover:rotate-180" />
        )}
      </div>
      
      {/* Sparkle effect for extra delight */}
      <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        <Sparkles className="h-3 w-3 text-primary absolute top-0 right-0 animate-bounce-slow" />
      </div>
      
      <span className="sr-only">Toggle theme</span>
    </Button>
  )
}
